import { createAction } from 'redux-actions';

export const markCurrentPageAsSeen = createAction(
  'BROWSE.MARK_PAGE_READ',
  () => ({})
);
